import React from 'react';
import { View, ScrollView, StyleSheet, Text, Platform } from 'react-native';
import { Title, Paragraph, IconButton } from 'react-native-paper';
import { MaterialCommunityIcons } from '@expo/vector-icons';

export default function AboutPage({ onClose }) {
  const isWeb = Platform.OS === 'web';

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <Title style={styles.title}>Hakkımızda</Title>
        <IconButton
          icon={() => <MaterialCommunityIcons name="close" size={24} color="#FFFFFF" />}
          onPress={onClose}
          style={styles.closeButton}
        />
      </View>
      <ScrollView style={styles.content} contentContainerStyle={styles.contentContainer}>
        <Paragraph style={styles.paragraph}>
          <Title style={styles.sectionTitle}>Şamata Play'e Hoş Geldiniz!</Title>
        </Paragraph>
        
        <Paragraph style={styles.paragraph}>
          Şamata Play, Türkiye'nin en kapsamlı canlı radyo dinleme ve sosyal eğlence platformudur. 
          Müzik severlerin bir araya geldiği, radyo dinlerken aynı zamanda oyun oynayabildiği, 
          sohbet edebildiği ve yeni arkadaşlar edinebildiği interaktif bir platform sunuyoruz.
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          Şamata, binlerce radyo istasyonunu tek bir platformda birleştirerek kesintisiz müzik deneyimi sunar.
          Canlı radyo, interaktif sohbet odaları, bilgi yarışması ve kelime avı gibi oyunlarla dinlerken sosyalleşebilirsiniz.
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          Türkçe Pop, Nostalji, Yabancı Müzik, Romantik/Slow, Türkü, Arabesk, Karadeniz, Klasik ve Haber kategorilerinde
          yüzlerce radyo istasyonuna erişebilir; favorilerinizi kaydedip son dinlediklerinizi takip edebilirsiniz.
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          Platform tamamen ücretsizdir ve kayıt gerekmez. Web tarayıcınızdan veya mobil uygulamamızdan hemen dinlemeye başlayabilir,
          chat odaları ve oyunlarla eğlenceli bir sosyal deneyim yaşayabilirsiniz.
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          <Title style={styles.sectionTitle}>Özelliklerimiz</Title>
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          <MaterialCommunityIcons name="radio" size={20} color="#E94560" /> <Text style={styles.bold}>Canlı Radyo Dinleme:</Text> 
          {'\n'}Türkiye'nin en popüler radyo istasyonlarını canlı olarak dinleyebilir, favorilerinizi kaydedebilir ve 
          son dinlediğiniz radyolara hızlıca erişebilirsiniz.
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          <MaterialCommunityIcons name="cards" size={20} color="#E94560" /> <Text style={styles.bold}>Online Kart Oyunları:</Text>
          {'\n'}Pişti, UNO ve Batak gibi klasik kart oyunlarını arkadaşlarınızla birlikte oynayabilir, 
          eğlenceli vakit geçirebilirsiniz.
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          <MaterialCommunityIcons name="chat" size={20} color="#E94560" /> <Text style={styles.bold}>Sosyal Sohbet:</Text>
          {'\n'}Radyo dinlerken aynı anda sohbet odalarında diğer dinleyicilerle konuşabilir, 
          yeni arkadaşlar edinebilir ve sosyalleşebilirsiniz.
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          <MaterialCommunityIcons name="puzzle" size={20} color="#E94560" /> <Text style={styles.bold}>Eğlenceli Oyunlar:</Text>
          {'\n'}Bilgi yarışması, kelime avı ve kategori savaşı gibi eğlenceli oyunlarla 
          müzik dinlerken eğlenebilirsiniz.
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          <Title style={styles.sectionTitle}>Misyonumuz</Title>
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          Şamata Play olarak, müzik severleri bir araya getiren, eğlenceli ve interaktif bir 
          platform sunmayı hedefliyoruz. Radyo dinleme deneyimini sosyal bir aktiviteye 
          dönüştürerek, kullanıcılarımıza unutulmaz anlar yaşatmayı amaçlıyoruz.
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          <Title style={styles.sectionTitle}>İletişim</Title>
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          Sorularınız, önerileriniz veya destek talepleriniz için lütfen İletişim sayfamızı ziyaret edin.
        </Paragraph>

        <View style={styles.footer}>
          <Paragraph style={styles.footerText}>
            © 2024 Şamata Play. Tüm hakları saklıdır.
          </Paragraph>
        </View>
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#000000',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingTop: Platform.OS === 'web' ? 20 : 40,
    paddingBottom: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#333333',
  },
  title: {
    color: '#FFFFFF',
    fontSize: 24,
    fontWeight: 'bold',
  },
  closeButton: {
    margin: 0,
  },
  content: {
    flex: 1,
  },
  contentContainer: {
    padding: 20,
    paddingBottom: 40,
  },
  paragraph: {
    color: '#CCCCCC',
    fontSize: 16,
    lineHeight: 24,
    marginBottom: 20,
  },
  sectionTitle: {
    color: '#FFFFFF',
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 10,
    marginTop: 10,
  },
  bold: {
    fontWeight: 'bold',
    color: '#FFFFFF',
  },
  footer: {
    marginTop: 40,
    paddingTop: 20,
    borderTopWidth: 1,
    borderTopColor: '#333333',
  },
  footerText: {
    color: '#888888',
    fontSize: 14,
    textAlign: 'center',
  },
});

